import React from 'react'
import parse from 'html-react-parser';
import { lu } from '../../data/reportData';
import { TAB, H1, H2, H2_1, TXC_B } from "../../styles/urar-styles";
import { IMAGE_RI, COMMENTARY, EXHIBITS, TABLE } from "../../styles/urar-styles";

export default function RENTAL_INFORMATION() {

	if (!global.ptr.sowDetail.rentScheduleIndicator) return;

	return (
		<>
			<TAB title="Rental Information" />
			<H1 title="Rent Schedule" />
			<H2 title="Subject Property Rental Information" />
			<TABLE titles={["","Currently Rented","Occupancy","Monthly Rent","Month-to-Month","Lease Start","Rent Control","Rent Concessions","Utilities/Services Included","Furnished"]} widths={[108,108,108,108,108,108,108,108,108,108]} values={lu("23.01.01-10")} />
			<TXC_B title="Description of Rent Control and Impact to Value/Marketability" value={lu("23.01.11")} />

			<div className='col2 mt-3'>
				<div>
					<H2_1 title="Actual Income (Monthly)" />
					<TB_IB title="Rent" values={lu("23.01.12-14")} total={lu("23.01.18.1")} />
					<TB_IB title="Other Real Property Rental Income" values={lu("23.01.15-17")} total={lu("23.01.18.2")} />
					<TB_IB_TOTAL total={lu("23.01.18")} />
				</div>
				<div>
					<H2_1 title="Opinion of Market Income (Monthly)" />
					<TB_IB title="Rent" values={lu("23.01.19-21")} total={lu("23.01.25.1")} />
					<TB_IB title="Other Real Property Rental Income" values={lu("23.01.22-24")} total={lu("23.01.25.2")} />
					<TB_IB_TOTAL total={lu("23.01.25")} />
				</div>
			</div>

			<H1 title="Comparable Rental Properties" />
			<TB_B6_HEADER images={lu("23.02.00")} values={lu("23.02.01")} />

			<H1 title="Comparable Rental Analysis" />
			<RENTAL_ANALYSIS values={lu("23.03.00")} />

			<COMMENTARY title="Rental Analysis Commentary" value={lu("23.04.01")} />
			<EXHIBITS title="Rental Information Exhibits" values={lu("23.099")}  />


		</>
	)
}

function RENTAL_ANALYSIS({values}) {
	//console.log("rav: ", values);
	return (
		<>
		{
			values.map((v, vi) => {
				if (v.length === 1 ) 
				{
					return (
						<RENTAL_ANALYSIS_SINGLE key={vi} values={v[0]} />
					)
				} else {
					return (
						<RENTAL_ANALYSIS_DOUBLE key={vi} values={v} />
					)
				}
				
			})
		}
		</>
	)
}

function RENTAL_ANALYSIS_DOUBLE({values}) {
	//console.log("DOUBLE", values);
	let left = values[0].slice(1);
	let right = values[1].slice(1);
	return (
		<div className='w-[1080px] '>
			<div className='flex flex-row' >
				<RA_SINGLE_HEADER values={values[0][0]} cn="ml-[190px]"/>
				<RA_SINGLE_HEADER values={values[1][0]} cn="ml-1"/>
			</div>
			<div className='flex flex-col mpr' >
			{
				left.map((v, vi) => {
					let top = (vi === 0) ? true : false;
					let bottom = (vi === left.length-1) ? true : false;

					return (
						<RA_DOUBLE_ROW key={vi} left={v} right={right[vi]} top={top} bottom={bottom} />
					)
				})
			}
			</div>
		</div>
	)
}

function RENTAL_ANALYSIS_SINGLE({values}) {
	//console.log("SINGLE", values);
	return (
		<div className='w-[1080px] '>
			<RA_SINGLE_HEADER values={values[0]} cn="ml-[190px]"/>
			<div className='flex flex-col mpr' >
			{
				values.slice(1).map((v, vi) => {
					let top = (vi === 0) ? true : false;
					let bottom = (vi === values.length-1) ? true : false;

					return (
						<RA_SINGLE_ROW key={vi} values={v} top={top} bottom={bottom} />
					)
				})
			}
			</div>
		</div>
	)
}

function RA_SINGLE_HEADER({values, cn}) {

	//console.log("HDR", values);
	return (
		<div className={'flex flex-row mpb ' + cn} >
			<div className='w-[110px] text-center flex flex-col justify-end whitespace-pre' >
				{values[1]}
			</div>
			<div className='flex flex-col' >
				<div className='text-center border-gray-500 border-b-[1px]'>Comparables</div>
				<div className='flex flex-row'>
				{
					values.slice(2).map((v, vi) => {
						return (
							<div key={vi} className='w-[110px] text-center' >{v}</div>
						)
					})
				}
				</div>
			</div>
		</div>
	)

}

function RA_DOUBLE_ROW({left, right, top, bottom}) {
	// console.log("DOUBLE_ROW Left", left);
	// console.log("DOUBLE_ROW Right", right);

	let ct = top ? " border-t-[2px]" : "";
	let cb = bottom ? " border-b-[2px]" : " border-b-[1px]";
	let cg = left[0] === "Summary" ? " bg-gray-300" : "";
	if (left[0].charAt(0) === "!") {
		cg += " mpb";
		left[0] = left[0].substring(1);
	}

	return (
		<div className='flex flex-row'>
			<div className={'px-1 mr-2 w-[184px] border-gray-500 border-l-[2px] border-r-[2px] whitespace-pre-wrap' + ct + cb + cg}>
				{left[0]}
			</div>
			<div className={'flex flex-row border-gray-500 border-l-[2px] border-r-[2px] mr-2' + ct + cb} >
				{
					left.map((v, vi) => {
						let bl = (vi === 0) ? "" : " border-gray-500 border-l-[1px]";
						if (v ==="EMPTY") {
							bl = " bg-gray-300";
							v = "";
						} else if (v === "GRAY") {
							bl += " bg-gray-300";
							v = "";
						}

						return (
							<React.Fragment key={vi}>
							{ vi > 0 &&
								<div className={'w-[110px] px-1 text-right whitespace-pre-wrap' + bl}>{v}</div>
							}
							</React.Fragment>
						)
					})
				}
			</div>
			<div className={'flex flex-row border-gray-500 border-l-[2px] border-r-[2px]' + ct + cb} >
				{
					right.map((v, vi) => {
						let bl = (vi === 0) ? "" : " border-gray-500 border-l-[1px]";
						if (v ==="EMPTY") {
							bl = " bg-gray-300";
							v = "";
						} else if (v === "GRAY") {
							bl += " bg-gray-300";
							v = "";
						}

						return (
							<React.Fragment key={vi}>
							{ vi > 0 &&
								<div key={vi} className={'w-[110px] px-1 text-right whitespace-pre-wrap' + bl}>{v}</div>
							}
							</React.Fragment>
						)
					})
				}
			</div>
		</div>
	)
}

function RA_SINGLE_ROW({values, top, bottom}) {
//	console.log("SINGLE_ROW", values);

	let ct = top ? " border-t-[2px]" : "";
	let cb = bottom ? " border-b-[2px]" : " border-b-[1px]";
	let cg = values[0] === "Summary" ? " bg-gray-300" : "";
	if (values[0].charAt(0) === "!") {
		cg += " mpb";
		values[0] = values[0].substring(1);
	}

	return (
		<div className='flex flex-row'>
			<div className={'px-1 mr-2 w-[184px] border-gray-500 border-l-[2px] border-r-[2px] whitespace-pre-wrap' + ct + cb + cg}>
				{values[0]}
			</div>
			<div className={'flex flex-row border-gray-500 border-l-[2px] border-r-[2px]' + ct + cb} >
				{
					values.map((v, vi) => {
						let bl = (vi === 0) ? "" : " border-gray-500 border-l-[1px]";
						if (v ==="EMPTY") {
							bl = " bg-gray-300";
							v = "";
						} else if (v === "GRAY") {
							bl += " bg-gray-300";
							v = "";
						}

						return (
							<React.Fragment key={vi}>
							{ vi > 0 &&
								<div key={vi} className={'w-[110px] px-1 text-right whitespace-pre-wrap' + bl}>{v}</div>
							}
							</React.Fragment>
						)
					})
				}
			</div>
		</div>
	)
}

function TB_IB({title, values, total}) {
	return (
		<div className='w-[528px] flex flex-col pt-2'>
			<div className="mpb border-b-[1px] border-gray-500 pl-4">
				{title}
			</div>
			{
				values.map((v, i) => {
					return (
						<div key={i} className="flex flex-row border-b-[1px] border-gray-500 mpr">
							<div className='w-[362px] border-r-[1px] border-gray-500 pl-8'>
								{v[0]}
							</div>
							<div className='w-[166px] text-right pr-20'>
								{v[1]}
							</div>
						</div>
					)
				})
			}
			<div className="flex flex=row mpb">
				<div className="w-[232px]"></div>
				<div className="w-[129px] border-l-[1px] border-b-[1px] border-gray-500 text-right pr-4">Subtotal</div>
				<div className='w-[167px] border-l-[1px] border-b-[1px] border-gray-500 text-right pr-20'>{total}</div>
			</div>
		</div>
	)
}

function TB_IB_TOTAL({total}) {
	return (
		<div className='w-[528px] flex flex-col'>
			<div className="flex flex=row mpb text-white">
				<div className="w-[232px]"></div>
				<div className="w-[130px] bg-gray-500 border-gray-500 text-right pr-4">Total</div>
				<div className='w-[166px] bg-gray-500 border-gray-500 text-right pr-20'>{total}</div>
			</div>
		</div>
	)
}

function TB_B6({values}) {
	// if more than 5 comparables, split the array
	let split = [];
	let ix = 0;
	while ( ix < values.length) {
		let line = [];
		if (ix > 0) line.push([""]);
		line.push(...values.slice(ix, ix+6));
		split.push(line);
		ix += 6;
	}

		return (
		<div>
			<div className={"flex flex-col"} >
			{
				split.map((s, si) => {

					return (
						<div key={si} className={"flex flex-row"}>
						{
							s.map((v, vi) => {
								//console.log("V", v);
								let bl = (vi === 0) ? "tbri-180" : "tbri-180-l";
								return (
									<React.Fragment key={vi} >
										<div  className={"flex flex-col " + bl}>
											<div className={"pl-2"}>
												{parse(v[0])}
											</div>
										</div>
									</React.Fragment>
								)
							})
						}
						</div>
					)
				})
			}
			</div>
		</div>
	)
}

function TB_B6_IMAGE({values}) {
	// if more than 5 comparables, split the array
	let split = [];
	if (values.length > 5) {
		let ix = 0;
		while ( ix < values.length) {
			let line = [];
			if (ix > 0) line.push([""]);
			line.push(...values.slice(ix, ix+6));
			split.push(line);
			ix += 6;
		}
	} else
		split = values;

	return (
		<div className={"flex flex-row"} >
		{
			split.map((s, si) => {
				//console.log("V", v);
				let bl = (si === 0) ? "tbrii-180" : "tbrii-180-l";
				return (
					<React.Fragment key={si} >
						<div  className={"flex flex-col " + bl }>
								<IMAGE_RI image={s} />
					</div>
					</React.Fragment>
				)
			})
		}
		</div>
		)
}

function TB_B6_HEADER({images, values}) {
	// if more than 5 comparables, split the array
	let vsplit = [];
	let isplit = [];

	// get the first 5 comparables
	let vline = [];
	vline.push(...values.slice(0, 6));
	vsplit.push(vline);

	let iline = [];
	iline.push(...images.slice(0, 6));
	isplit.push(iline);

	let ix = 6;
	while ( ix < values.length) {
		let vline = [];
		vline.push("");
		vline.push(...values.slice(ix, ix+5));
		vsplit.push(vline);

		let iline = [];
		iline.push(null);
		iline.push(...images.slice(ix, ix+5));
		isplit.push(iline);
		ix += 5;
	}

	return (
		<div className='mt-4' >
			{
				vsplit.map((vs, vsi) => {
					let ss = isplit[vsi];

					return (
						<div key={vsi} className='flex flex-col'>
						<div className={"flex flex-row"}>
						{
							ss.map((s, si) => {
								//console.log("V", v);
								let bl = (vsi === 0) ? ((si === 0) ? "tbrii-180" : "tbrii-180-l") : ((si === 0) ? "tbrii-180-nb-nt" : "tbrii-180-nt-l") ;
								return (
									<React.Fragment key={si} >
											<div  className={"flex flex-col " + bl }>
												<IMAGE_RI image={s} />
											</div>
									</React.Fragment>
								)
							})
							}
							</div>
							<div key={vsi} className={"flex flex-row"}>
							{
								vs.map((v, vi) => {
									//console.log("V", v);
									let bl = (vi === 0) ? "tbri-180" : "tbri-180-l";
									return (
										<React.Fragment key={vi} >
											<div  className={"flex flex-col " + bl}>
												<div className={"pl-2"}>
													{parse(v)}
												</div>
											</div>
										</React.Fragment>
									)
								})
							}
						</div>
						</div>
					)
				})
			}
		</div>
	)
}
